// extracted by mini-css-extract-plugin
export default {"page__container":"TaskForm_page__container__jJLR2"};